import type {
  // @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'EventTemplate'. Did you mean to use 'import EventTemplate from "src/api-parsers/events"' instead?
  EventTemplate,
  // @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'TemplateBrandingSettings'. Did you mean to use 'import TemplateBrandingSettings from "src/api-parsers/events"' instead?
  TemplateBrandingSettings,
} from 'src/api-parsers/events';
// @ts-expect-error - TS2614 - Module '"src/api-parsers/index"' has no exported member 'Agency'. Did you mean to use 'import Agency from "src/api-parsers/index"' instead?
import type {Agency} from 'src/api-parsers/index';
import IndexStore from 'src/stores/index';
import type {State as ReduxState} from 'src/reducers';

import * as React from 'react';
import {withI18n} from 'src/utils/language-support';
import {connect} from 'react-redux';
import flow from 'lodash/flow';
import map from 'lodash/map';
import partial from 'lodash/partial';
import omit from 'lodash/omit';
import sculpt from 'sculpt';

import logger from 'src/utils/logger';

import {fluxify} from 'src/flux/component';
import {uploadMedia} from 'src/actions';

import Switch from 'src/components/lib/switch';
import ImageInput from 'src/components/settings/image-input';
import ColorPicker from 'src/components/lib/color-picker/color-picker';

import css from './variables.css';

// TODO (kyle): this should probably go somewhere central
const socialNetworks = {
  twitter: 'Twitter',
  linkedin: 'Linkedin',
  facebook: 'Facebook',
  instagram: 'Instagram',
  youtube: 'Youtube',
  'google-plus': 'Google+',
} as const;

const subscribeOptions = [
  {label: 'Show', value: true},
  {label: 'Hide', value: false},
];

type Props = {
  template: EventTemplate;
  agency: Agency;
  store: IndexStore;
  onChange: (arg1?: boolean | null | undefined) => unknown;
  t: (key: string, value: string) => string;
  fluxRef?: (component?: any | null | undefined) => void;
};

type State = {
  templateSettings: TemplateBrandingSettings;
  name: string;
};

const mapStateToProps = (state: ReduxState) => ({
  agency: state.agency.agency,
});

class TemplateVariables extends React.PureComponent<Props, State> {
  // @ts-expect-error - TS2564 - Property 'iframeElt' has no initializer and is not definitely assigned in the constructor.
  iframeElt: HTMLIFrameElement;

  constructor(props: any) {
    super(props);

    this.state = {
      templateSettings: props.template.templateSettings,
      name: props.template.name,
    };

    (this as any).handleLogoChange = this.handleLogoChange.bind(this);
    (this as any).handleLogoDelete = this.handleLogoDelete.bind(this);
    (this as any).handleColorChange = this.handleColorChange.bind(this);
    (this as any).handleLinkChange = this.handleLinkChange.bind(this);
    (this as any).handleCheckChange = this.handleCheckChange.bind(this);
    (this as any).handleInputChange = this.handleInputChange.bind(this);
    (this as any).handleNameChange = this.handleNameChange.bind(this);
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'PureComponent<Props, State, any>'.
  componentDidMount() {
    if (this.props.fluxRef) {
      this.props.fluxRef(this);
    }
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'PureComponent<Props, State, any>'.
  componentWillUnmount() {
    if (this.props.fluxRef) {
      this.props.fluxRef(null);
    }
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'PureComponent<Props, State, any>'.
  render() {
    const {template, t} = this.props;
    const {templateType, builtinType, sourceTemplateId} = template;
    const {
      name,
      templateSettings: {
        logo,
        logoLink,
        color,
        bgColor,
        boxColor,
        signature,
        links,
        footerText,
        showUnsubscribe,
        buttonColor,
      },
    } = this.state;
    const isCustom = templateType === 'custom';
    const isStandard = builtinType === 'standard';
    const isDefault = builtinType === 'default';
    const isOriginal = sourceTemplateId === null;

    return (
      <div className={css.rightColumn}>
        <div className={isCustom ? css.disabledColumn : css.settingsColumn}>
          {!isOriginal && (
            <div className={css.flexColumn}>
              <p className={css.topLabel}>{t('Name', 'Name')}</p>
              <input
                type="text"
                className={css.textInput}
                value={name}
                onChange={this.handleNameChange}
              />
            </div>
          )}

          <p className={css.label}>{t('Logo', 'Logo')}</p>
          <div className={css.logoInput}>
            <ImageInput
              src={logo}
              onChange={this.handleLogoChange}
              onDelete={this.handleLogoDelete}
            />
          </div>
          <p className={css.label}>{t('Logo_Link', 'Logo Link')}</p>
          <input
            type="text"
            placeholder="e.g. https://www.sensehq.com/"
            name="logoLink"
            className={css.textInput}
            value={logoLink}
            onChange={this.handleInputChange}
          />

          <p className={css.label}>{t('Brand_Color', 'Brand Color')}</p>
          <ColorPicker
            name="color"
            defaultValue={color}
            onChange={this.handleColorChange}
          />
          <p className={css.label}>{t('Button_Color', 'Button Color')}</p>
          <ColorPicker
            name="buttonColor"
            defaultValue={buttonColor}
            onChange={this.handleColorChange}
          />
          {isStandard && (
            <div className={css.flexColumn}>
              <p className={css.label}>
                {t('Background_Color', 'Background Color')}
              </p>
              <ColorPicker
                name="bgColor"
                defaultValue={bgColor || '#f0f0f0'}
                onChange={this.handleColorChange}
              />
              <p className={css.label}>
                {t('HeaderFooter_Color', 'Header/Footer Color')}
              </p>
              <ColorPicker
                name="boxColor"
                defaultValue={boxColor || color || '#000000'}
                onChange={this.handleColorChange}
              />
              {map(socialNetworks, (name, value) => (
                <label className={css.linkLabel} key={value}>
                  <div className={css.label}>{name}</div>
                  <input
                    type="text"
                    className={css.textInput}
                    value={links[value] || ''}
                    onChange={partial(this.handleLinkChange, value)}
                  />
                </label>
              ))}

              {/*
              (nilarnab) Hiding this for now
              <div className={css.linkLabel}>
                <div className={css.label}>Unsubscribe Link</div>
                <Switch
                  className={css.unsubscribeSwitch}
                  name="showUnsubscribe"
                  options={subscribeOptions}
                  checked={showUnsubscribe}
                  onChange={this.handleCheckChange}
                />
              </div> */}

              <label className={css.linkLabel}>
                <div className={css.label}>
                  {t('Footer_Text', 'Footer Text')}
                </div>
                <textarea
                  className={css.textarea}
                  name="footerText"
                  value={footerText}
                  onChange={this.handleInputChange}
                />
              </label>
            </div>
          )}

          {/*
          (nilarnab) Hiding this for now
          {isDefault && (
            <div className={css.flexColumn}>
              <div className={css.linkLabel}>
                <div className={css.label}>Unsubscribe Link</div>
                <Switch
                  className={css.unsubscribeSwitch}
                  name="showUnsubscribe"
                  options={subscribeOptions}
                  checked={showUnsubscribe}
                  onChange={this.handleCheckChange}
                />
              </div>
            </div>
          )} */}

          <p className={css.label}>{t('Signature', 'Signature')}</p>
          <textarea
            placeholder={t('signature', 'signature')}
            className={css.textarea}
            name="signature"
            value={signature}
            onChange={this.handleInputChange}
          />
        </div>
      </div>
    );
  }

  getTemplate() {
    return {...this.state};
  }

  // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
  handleLogoChange(event) {
    uploadMedia(this.props.store, event.target.files[0]).then(
      // @ts-expect-error - TS7006 - Parameter 'resp' implicitly has an 'any' type.
      (resp) => {
        this.setState(
          {
            templateSettings: {...this.state.templateSettings, logo: resp.url},
          },
          () => this.props.onChange(),
        );
      },
      // @ts-expect-error - TS7006 - Parameter 'err' implicitly has an 'any' type.
      (err) => {
        logger.error(err.stack || err.response.body);
      },
    );
  }

  handleLogoDelete() {
    const {logo, ...rest} = this.state.templateSettings;
    if (logo) {
      this.setState({templateSettings: rest}, () => this.props.onChange());
    }
  }

  handleColorChange(color: string, key: string = 'color') {
    let templateSettings;
    if (color) {
      templateSettings = {...this.state.templateSettings, [key]: color};
    } else {
      templateSettings = omit(this.state.templateSettings, key);
    }
    this.setState({templateSettings}, () => this.props.onChange());
  }

  handleLinkChange(type: any, event: any) {
    const {value} = event.target;
    const {templateSettings} = this.state;
    const spec = value.trim() ? {$assign: {[type]: value}} : {$unset: type};

    // @ts-expect-error - TS2349 - This expression is not callable.
    const links = sculpt(templateSettings.links, spec);

    // NOTE (kyle): eventually we'll allow for custom ordering
    const linkOrder = map(socialNetworks, (label, type) => type).filter(
      (type) => links[type],
    );

    this.setState(
      {
        templateSettings: {...templateSettings, links, linkOrder},
      },
      () => this.props.onChange(),
    );
  }

  handleCheckChange(event: any) {
    const {name, checked} = event.target;
    this.setState(
      {
        templateSettings: {
          ...this.state.templateSettings,
          [name]: checked,
        },
      },
      () => this.props.onChange(),
    );
  }

  handleInputChange(event: any) {
    const {templateSettings} = this.state;
    const {name, value} = event.target;
    const trimmedValue = value.trim();

    const spec = trimmedValue ? {$assign: {[name]: value}} : {$unset: name};
    const refresh = name !== 'logoLink';

    this.setState(
      {
        // @ts-expect-error - TS2349 - This expression is not callable.
        templateSettings: sculpt(templateSettings, spec),
      },
      () => this.props.onChange(refresh),
    );
  }

  handleNameChange(event: any) {
    this.setState(
      {
        name: event.target.value,
      },
      () => this.props.onChange(),
    );
  }
}

export default flow(
  fluxify(),
  connect(mapStateToProps),
  withI18n,
)(TemplateVariables) as any;
